import { forwardRef } from '@chakra-ui/react';
import MenuItem, { MenuItemProps } from '../Menu/MenuItem';

export interface OverflowMenuItemProps extends MenuItemProps {
  children: MenuItemProps['children'];
}

const OverflowMenuItem = forwardRef<OverflowMenuItemProps, 'button'>((props, ref) => {
  return <MenuItem {...props} ref={ref} />;
});

export default OverflowMenuItem;
